import type {
  DatatableField,
  DatatableSort,
  FilterField,
} from '../Widgets/types';
import type {
  ReportingEngineTicketBoardViewColumn,
  ReportingEngineTicketingReportingWidgetDefinition,
  ReportingEngineDefinitionDatatableSort,
  ReportingEngineTicketFieldFilter,
} from '../_api/types';

export const getDefinition = (
  allFields: DatatableField[],
  datatableFields: DatatableField[],
  datatableSort: DatatableSort | null,
  filters: FilterField[],
  satisfyAll: boolean
): ReportingEngineTicketingReportingWidgetDefinition => {
  const columns: ReportingEngineTicketBoardViewColumn[] = [];
  for (const field of datatableFields) {
    columns.push({
      label: field.label,
      ticketFieldId: field.id,
    });
  }

  const filterValues: ReportingEngineTicketFieldFilter[] = [];
  for (const filter of filters) {
    const field = allFields.find((f) => f.id === filter.id);
    if (field) {
      filterValues.push({
        ticketFieldId: field.id,
        operator: filter.operator,
        comparator: filter.value,
        comparatorNum: filter.comparatorNum,
        comparatorUnit: filter.comparatorUnit,
      });
    }
  }

  const definition: ReportingEngineTicketingReportingWidgetDefinition = {
    filters: {
      filters: filterValues,
      satisfyAll,
    },
    datatable: {
      columns,
    },
    visualization: null,
  };

  if (datatableSort) {
    const sortField = allFields.find(
      (field) => field.id === datatableSort.sortBy
    );

    if (sortField) {
      const sort: ReportingEngineDefinitionDatatableSort = {
        order: datatableSort.orderBy,
        column: {
          ticketFieldId: sortField.id,
        },
      };

      definition.datatable.sort = sort;
    }
  }

  return definition;
};

// convert array of entity sources to a comma separated string
// remove "all" from the array if it exists
export const convertEntitySourceFromArrayToComma = (
  entitySources: string[]
): string => entitySources.join(',');

export const convertEntitySourceFromCommaToArray = (
  entitySource: string
): string[] => entitySource.split(',');
